import React from "react";
import { Compass, Target, Handshake } from "lucide-react";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-white py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-5">
          <div className="overline mb-5">About TAQAVED</div>
          <h2
            className="font-display text-4xl md:text-5xl font-medium text-[#0A1128] leading-[1.05] tracking-tight"
            data-testid="about-title"
          >
            Energy with Purpose.
            <br />
            <span className="text-[#059669] italic">Strategy</span> with Impact.
          </h2>

          <div className="mt-10 hidden lg:block">
            <svg viewBox="0 0 320 220" className="w-full max-w-sm">
              <defs>
                <linearGradient id="lg1" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0%" stopColor="#059669" />
                  <stop offset="100%" stopColor="#00D084" />
                </linearGradient>
              </defs>
              {/* Circuit leaf */}
              <path
                d="M40 160 C 60 80, 160 40, 280 60 C 280 140, 200 200, 100 200 C 60 200, 40 190, 40 160 Z"
                fill="url(#lg1)"
                opacity="0.14"
              />
              <path
                d="M50 160 C 100 120, 160 90, 260 80"
                stroke="#059669"
                strokeWidth="1.5"
                fill="none"
              />
              <path
                d="M80 190 C 120 150, 180 120, 240 110"
                stroke="#0A1128"
                strokeWidth="1"
                fill="none"
                opacity="0.4"
              />
              {[60, 120, 180, 240].map((x) => (
                <circle key={x} cx={x} cy="130" r="3" fill="#0A1128" />
              ))}
              <circle cx="260" cy="80" r="5" fill="#00D084" />
            </svg>
          </div>
        </div>

        <div className="lg:col-span-7">
          <p
            className="text-lg md:text-xl text-slate-600 leading-relaxed"
            data-testid="about-body"
          >
            TAQAVED is a consulting and technology solutions company focused on helping businesses
            identify, structure and execute high-growth opportunities in Saudi Arabia and emerging
            markets. We combine strategic advisory, technology integration, localization planning,
            business development and implementation support — turning ambitious ideas into
            investable, resilient and scalable ventures.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-12">
            {[
              { icon: Compass, title: "Strategy", desc: "Investor-grade planning" },
              { icon: Target, title: "Localization", desc: "KSA / GCC market fit" },
              { icon: Handshake, title: "Execution", desc: "Partner-led delivery" },
            ].map((p, i) => (
              <div
                key={i}
                className="border border-slate-200 p-6 rounded-xl bg-[#F4F5F7]/60 card-lift"
                data-testid={`about-pillar-${i}`}
              >
                <p.icon className="w-5 h-5 text-[#059669]" />
                <div className="mt-4 font-semibold text-[#0A1128]">{p.title}</div>
                <div className="text-sm text-slate-500 mt-1">{p.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
